export default "__VITE_ASSET__c425be7b__"